import { ContactSearchRequest } from '@trukt/tms-api/contact-services';
import { createKey } from './createKey';

const keyHandler = createKey('contacts');

export const ContactServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<ContactSearchRequest>(),
};
